<div id="test-map" [attr.id]="mapIDTest" style="display: flex; height: 100%; flex: 1; ">
    <div class="loading-wrapper" *ngIf="isLoading">
        <mat-spinner></mat-spinner>
    </div>

    <mat-card *ngIf="!isLoading" (wheel)="$event.stopPropagation()" (mousedown)="$event.stopPropagation()"
        (click)="$event.stopPropagation()" (mousemove)="$event.stopPropagation()" class="leaderboard-card">
        <mat-card-header>
            <mat-card-title>Leaderboard</mat-card-title>
        </mat-card-header>
        <mat-card-content style="width:250px;">
            <mat-table [dataSource]="leaderboardList.slice(0,5)" style="width: 100%;">

                <!-- Country Column -->
                <ng-container matColumnDef="country">
                    <mat-header-cell *matHeaderCellDef style="font-weight: bold;"> Country </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.name}} </mat-cell>
                </ng-container>

                <!-- Count Column -->
                <ng-container matColumnDef="count">
                    <mat-header-cell *matHeaderCellDef style="font-weight: bold;"> Count </mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.count}} </mat-cell>
                </ng-container>

                <!-- Action Column -->
                <ng-container matColumnDef="action">
                    <mat-header-cell *matHeaderCellDef style="font-weight: bold;"> Action </mat-header-cell>
                    <mat-cell *matCellDef="let element">
                        <button mat-icon-button [matMenuTriggerFor]="matActionMenu" [matMenuTriggerData]="{iso :element.name}">
                            <mat-icon>more_vert</mat-icon>
                        </button>
                    </mat-cell>
                </ng-container>

                <!-- Header and Row Declarations -->
                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
            </mat-table>

        </mat-card-content>
    </mat-card>

</div>

<mat-menu #matActionMenu="matMenu">
    <ng-template matMenuContent let-iso="iso">
        <button mat-menu-item (click)="onOpenTickets($event, iso)">Open Overview</button>
    </ng-template>
</mat-menu>